import React, {  useState } from 'react';
import Select, { components } from 'react-select';
import { CreatedDate, StartDate } from '../component/DatePicker';
import moment from 'moment';
import { KEY_LEAD_ACTIVE_TAB_MAP } from '@src/config/constant';
import { useLanguage } from "@src/context/LanguageContext";
const { ValueContainer, Placeholder } = components;

const CustomValueContainer = (props: any) => {
  return (
    <ValueContainer {...props}>
      <Placeholder {...props} isFocused={props.isFocused}>
        {props.selectProps.placeholder}
      </Placeholder>
      {React.Children.map(props.children, (child: any) =>
        child && child.type !== Placeholder ? child : null
      )}
    </ValueContainer>
  );
};

type OptionType = {
  value: string;
  label: string;
};

const LeadListFilter = (props: any) => {
    const { submitHandler, selectedFilters, setSelectedFilters, statusFilterList, typeList } = props;
    const {translations} = useLanguage();
    const [errorState, setErrorState] = useState<any>({
        start_date: '',
        end_date: '',
    });

    const handleChange = (selectedOption: any, key: string) => {
        let value: any = null;
        let updatedErrors = { ...errorState };

        if (key === 'created_on' || key === 'start_date' || key === 'end_date') {
            value = moment(selectedOption).format('YYYY-MM-DD');

            // Validate start_date if end_date exists
            if (key === 'start_date' && selectedFilters.end_date) {
                if (moment(value).isAfter(selectedFilters.end_date)) {
                    updatedErrors.start_date = "Start date must be less.";
                } else {
                    updatedErrors.start_date = '';
                }
            }

            // Validate end_date if start_date exists
            if (key === 'end_date' && selectedFilters.start_date) {
                if (moment(value).isBefore(selectedFilters.start_date)) {
                    updatedErrors.end_date = "End date must be greater.";
                } else {
                    updatedErrors.end_date = '';
                }
            }
        } else if (key === 'searchKeyword') {
            value = selectedOption.target.value;
        } else {
            value = selectedOption.value;
        }

        if (!updatedErrors.start_date && !updatedErrors.end_date) {
            setSelectedFilters((prev: any) => ({
                ...prev,
                [key]: value
            }));
        }

        setErrorState(updatedErrors);
    };

    /**
    * FILTER SET HANDLER
    */
    const onFilterSearch = () => {
        if (!errorState.start_date && !errorState.end_date && Object.keys(selectedFilters).length) {
            submitHandler({ page_number: 1, ...selectedFilters });
        }
    }

    /**
     * FILTER RESET HANDLER
     */
    const onFilterReset = () => {
        if(Object.keys(selectedFilters).length){
            setSelectedFilters({});
            submitHandler({ page_number: 1, activeTab: KEY_LEAD_ACTIVE_TAB_MAP['first'] });
        }
    }

    const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
        if (e.key !== 'Enter') return;

        const target = e.target as HTMLElement;

        // Agar react-select ka dropdown menu khula hai, to Enter usi ko
        // option-select karne dena hai — search trigger nahi karni
        const isSelectMenuOpen = document.querySelector('.react-select__menu');
        if (isSelectMenuOpen) return;

        e.preventDefault();
        onFilterSearch();
    };

  return (
    <div className="lead-list-filter">
    <div className="filter-filed-form" onKeyDown={handleKeyDown}>
        <fieldset className="search-bx">
        <div className="material">
            <input
            type="text"
            placeholder={translations.Insurance?.INSURANCE_FILTER?.['SEARCH_BY_ID_NAME'] || translations.commonMsg?.loading}
            name="search"
            className="form-input"
            aria-label="Search by Lead ID or Name"
            title="Search by Lead ID or Name"
            onChange={(e) => handleChange(e, 'searchKeyword')} value={selectedFilters?.searchKeyword || ""} 
            />
            <i className="ic-search"></i>
        </div>
        </fieldset>
        <fieldset className="single-select">
        <div className="material">
            <Select<OptionType>
            components={{ ValueContainer: CustomValueContainer }}
            options={typeList}
            placeholder={translations.Insurance?.INSURANCE_FILTER?.['TYPE'] || translations.commonMsg?.loading}
            className="react-select"
            classNamePrefix="react-select"
            isClearable
            isSearchable={false}
            onChange={(e: any) => handleChange(e, 'insurance_type')}
            value={typeList?.find((option: any) => option.value === selectedFilters.insurance_type) || null}
            />
        </div>
        </fieldset>

        <fieldset className="date-filed">
        <div className="material">
            <CreatedDate selectedFilters={selectedFilters} placeholder={translations.Insurance?.INSURANCE_FILTER?.['CREATED_ON'] || translations.commonMsg?.loading} handleChange={handleChange}/>
        </div>
        </fieldset>
        <fieldset className="date-filed">
        <div className="material">
            <StartDate selectedFilters={selectedFilters} placeholder={translations.Insurance?.INSURANCE_FILTER?.['POLICY_START_DATE'] || translations.commonMsg?.loading} handleChange={handleChange}/>
            {errorState.start_date && <span  className = ""style={{ color: 'red' }}>{errorState.start_date}</span>} 
        </div>
        </fieldset>
        <fieldset className="single-select">
        <div className="material">
            <Select<OptionType>
            components={{ ValueContainer: CustomValueContainer }}
            options={statusFilterList}
            placeholder={translations.Insurance?.INSURANCE_FILTER?.['STATUS'] || translations.commonMsg?.loading}
            className="react-select"
            classNamePrefix="react-select"
            isClearable
            isSearchable={false}
            onChange={(e: any) => handleChange(e, 'status')}
            value={statusFilterList.find((option: any) => option.value === selectedFilters.status) || null}
            />
        </div>
        </fieldset>
        <div className="btn-submit-reset">
            <button className="btn-primary" onClick={onFilterSearch}>{translations.Insurance?.INSURANCE_FILTER?.['SEARCH'] || translations.commonMsg?.loading}</button>
            <button className="btn-reset" onClick={onFilterReset}>{translations.Insurance?.INSURANCE_FILTER?.['RESET'] || translations.commonMsg?.loading}</button>
        </div>
    </div>
    </div>
  );
}
export default LeadListFilter;

